import { Viewport, useMatchMedia } from "@repo/ui/viewport";

export const smallBreakpoint = 720;

const config = {
  small: {
    className: "viewportSmall",
    mediaQuery: `(width <= ${smallBreakpoint}px)`,
  },
  large: {
    className: "viewportLarge",
    mediaQuery: `(width > ${smallBreakpoint}px)`,
  },
};

export const Small = ({ children }: { children: React.ReactNode }) => (
  <Viewport is={config.small}>{children}</Viewport>
);
export const Large = ({ children }: { children: React.ReactNode }) => (
  <Viewport is={config.large}>{children}</Viewport>
);

export const useSmallViewport = () => !!useMatchMedia(config.small);
export const useLargeViewport = () => !!useMatchMedia(config.large);
